<style lang="scss" scoped>
  .app {
    width: 100vw;
    height: 100vh;
    display: flex;
  }
  .main {
    overflow-y: auto;
    flex: 1 0 0;
  }
</style>
<template>
  <div>
    <div class="app">
      <v-main-navigationbar></v-main-navigationbar>
      <main class="main">
        <slot></slot>
      </main>
    </div>
    <v-alerts></v-alerts>
    <v-overlay></v-overlay>
    <v-overlay-popup></v-overlay-popup>
  </div>
</template>

<script>
import Alerts from '@/components/alerts';
import Modal from '@/components/modal';
import MainNavigationBar from '@/components/mainNavigationBar';
import Overlay from '@/components/overlay';
import OverlayPopup from '@/components/OverlayPopup';

export default {
  name: 'app',
  data() {
    return {
      user: []
    };
  },
  components: {
    'v-alerts': Alerts,
    'v-modal': Modal,
    'v-main-navigationbar': MainNavigationBar,
    'v-overlay': Overlay,
    'v-overlay-popup': OverlayPopup
  }
};
</script>



// WEBPACK FOOTER //
// src/layouts/default.vue